export enum ReviewerRoleCode {
  MachineOwner = 1,
  ServiceProvider = 2,
}

export interface ServiceReview {
  id: string;
  serviceRequestId: string;
  offerId: string;
  reviewerCustomerId: string;
  reviewerCompanyName: string;
  revieweeCustomerId: string;
  revieweeCompanyName: string;
  reviewerRoleCode: ReviewerRoleCode;
  rating: number;
  title?: string;
  comment?: string;
  createdDate: string;
}

export interface CreateReviewRequest {
  serviceRequestId: string;
  offerId: string;
  rating: number;
  title?: string;
  comment?: string;
}

export interface CustomerReviewSummary {
  averageRating: number;
  totalCount: number;
  fiveStarCount: number;
  fourStarCount: number;
  threeStarCount: number;
  twoStarCount: number;
  oneStarCount: number;
}

export interface ReviewCheck {
  hasReviewed: boolean;
  review?: ServiceReview;
}

export interface ReviewListResponse {
  reviews: ServiceReview[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface ServiceReviewsState {
  reviews: ServiceReview[];
  reviewCheck: ReviewCheck | null;
  summary: CustomerReviewSummary | null;
  loading: boolean;
  submitting: boolean;
  error: any;
}
